import { render, staticRenderFns } from "./ResponsibilityModal.vue?vue&type=template&id=0062ed4c&"
import script from "./ResponsibilityModal.vue?vue&type=script&lang=js&"
export * from "./ResponsibilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports